<template>
    <div class="main-container">
        <router-view></router-view>
		<!-- Navbar section -->
		<HeaderSoftware />

        <!-- hero section -->
        <HeroBranding /> 

        <!-- fun facts section -->
		<div class="fun-fact-wrapper section-space--pt_60 section-space--pb_60">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="section-title text-center section-space--mb_60">
                            <h2 class="font-weight--light mb-15 wow move-up">{{ $t('hikayeyoksadecegercekler') }}</h2>
                            <h5 class="section-text wow move-up">{{ $t('slogan2') }}</h5>
                            <p>{{ $t('sektorler') }}</p>
                            <h6>{{ $t('thanks') }}</h6>
                        </div>
                    </div>
                </div>
				<!-- fun fact component -->
				<FunFactOne />
           

        <br>
        <div id="datagrid" >
        <DxDataGrid 
    :data-source="dataSource"
    :show-borders="true"
    :focused-row-enabled="true"
    :allow-column-reordering="false"
    :row-alternation-enabled="true"
    ShowScrollbarMode="Always"
  >
    <DxColumn data-field="sKodu" caption="ID" width="70"/>
    <DxColumn data-field="sAciklama" :caption="$t('aciklama')"/>
    <DxColumn data-field="dteKayitTarihi" :caption="$t('tarih')" sort-order="desc" format="dd/MM/yy" width="80"/>
    <DxColumn data-field="sIl" :caption="$t('sehir')" width="80"/>
    <DxSelection mode="single"/>
    <DxFilterRow :visible="false"/>
    <dxSorting mode="none"/>
    <DxScrolling  showScrollbar="Always"/>
    <DxPager
    :visible="false"
            :show-info="true"
            info-text="Page #{0}. Total: {1} ({2} items)"
        />
  </DxDataGrid>
  </div>
   </div>
		</div>
  <br>

       <!-- brand logo carousel -->
		<BrandLogoCarousel />
        
        <CtaThree />

        <!-- footer section -->
        <FooterMain />

        <!-- offcanvas search component -->
        <OffcanvasSearchBox />

        <!-- off-canvas mobile menu -->
        <OffCanvasMobileMenu />

    </div>
</template>

<script>
    import HeaderSoftware from "../components/HeaderSoftware";
    import HeroBranding from "../components/HeroBranding"
    //import HeaderElement from '@/components/HeaderElement'
    //import Breadcrumb from '@/components/Breadcrumb'
    import CtaFour from '@/components/CtaFour'
    import CtaThree from '@/components/CtaThree'
    import FooterMain from '@/components/FooterMain'
    import OffcanvasSearchBox from '@/components/OffcanvasSearchBox'
    import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'
    import FunFactOne from "../components/FunFactOne";
    import BrandLogoCarousel from "../components/BrandLogoCarousel";
    import 'devextreme/data/odata/store';
    
    import { DxDataGrid, DxSelection, DxFilterRow,  DxSorting, DxPager, DxColumn,DxScrolling } from 'devextreme-vue/data-grid';
    import axios from 'axios';
    import qs from 'qs';

    import {mobilit} from '../utils/sharedconfig.js'
    
    export default {
        name: 'ElementCta',
        components: {
            HeaderSoftware,
            HeroBranding,
            BrandLogoCarousel,
            //HeaderElement,
            //Breadcrumb,
            CtaFour,
            CtaThree,
            FooterMain,
            OffcanvasSearchBox,
            OffCanvasMobileMenu,
            FunFactOne,
           DxDataGrid, DxSelection, DxFilterRow,  DxPager, DxColumn,DxScrolling,DxSorting
            
        },
        data() {
        return {
      dataSource: {
        store: mobilit.tbFirma,
        //paginate: true,
        pageSize: 50,
        select: [
          'nFirmaID',
          'sKodu',
          'sAciklama',
          'dteKayitTarihi',
          'sIl',
        
        ],
        filter: ['sKodu', 'contains', '10'],
        sort: {field:'dteKayitTarihi',desc:true},
        

        
      }
    };
  
    }
    
    }
</script>

